import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const upload = async ( folder = 'files', file, user = "user", deleteFile = null) => {
  // Evita llamadas vacías al backend cuando no hay archivo
  if (file === null || file === undefined) return null;
  const formData = new FormData();
  formData.append('folder', folder);
  formData.append('file', file);
  formData.append('user', user);
  if (deleteFile) 
    formData.append('deleteFile', deleteFile);
  const headers = { 'Content-Type': 'multipart/form-data' };
  try{
    const response = await axios.post(rutas.axios + 'api/upload/', formData, headers);
    if( response.status !== 200) return null;
    return response.data.url;
  }catch(error){
    console.log(error);
    return null;
  }
}

const deleteFile = async (filePath) => {
  const formData = new FormData();
  formData.append('filePath', filePath);
  const headers = { 'Content-Type': 'multipart/form-data' };
  try{
    const response = await axios.post(rutas.axios + 'file/delete/', formData, headers);
    if( response.status !== 200) return null;
    return true;
  }catch(error){
    console.log(error);
    return null;
  }
}


export const fileService = {
  upload,
  deleteFile
}
